<div *ngIf="isLoaded()" class="registration-container">
  <div>
    <dip-registration-header></dip-registration-header>
    <main role="main">
      <router-outlet></router-outlet>
    </main>
  </div>
  <dip-registration-footer></dip-registration-footer>
</div>
